import GenericMessage from './GenericMessage';
import styles from './info-message.module.less';

const InfoMessage = ({ children, icon = 'info', className = '', column }) => (
    <GenericMessage
        icon={icon}
        iconStyle={styles.icon}
        containerStyle={styles.messageContainer}
        textStyle={styles.text}
        className={className}
        column={column}
    >
        {children}
    </GenericMessage>
);

export default InfoMessage;
